export const squareAreaUOMTypes = [{
    type:  'Square Feet',
    value: 'SquareFootage'
},
{
    type:  'Square Meters',
    value: 'SquareMeters'
}];
